import { writable, derived } from 'svelte/store';

// Type definitions
type Language = 'en' | 'es';
type TranslationKey = 'User Profile' | 'First Name' | 'Last Name' | 'E-mail' | 'Phone Number' | 'Role' | 'Country' | 'Currency Code' | 'Referral'
                      | 'Add Group' | 'Name' | 'Parent-id' | 'Options' | 'Profile' | 'Transactions'| 'Sums' | 'Campaigns' | 'Rounds' | 'Game Servers' 
                      | 'Games' | 'Banners'| 'Administrators' | 'Cashiers' | 'Unassigned'|'Players' | 'Games Groups' | 'User Groups' | 'Logout' 
                      | 'Transaction' | 'real time update active' |'Start Date' | 'End Date' | 'Search by name' | '1 Week' | '2 Weeks' | '1 Month' 
                      | 'Summary by Type of Transaction' | 'Type of transaction' | 'Count'| 'Amount' | 'Total' | 'No transactions were found for the selected dates.' 
                      | 'Transaction List' | 'Transaction date' | 'Type' | 'User' |  'Balance' | 'Money Amount' | 'Money Balance' | 'Promo Amount' 
                      | 'Previous' | 'Page' | 'Next'| 'Total Promotion' | 'No promotion' | 'Groups' | 'Select All' | 'Loading' | 'Search' | 'No results found' 
                      | 'No data available for the selected period' | 'Transaction Summary' | 'Less' | 'More' | 'Deposit' | 'Withdraw' | 'Deposit Profit' | 'Bet'
                      | 'Win' | 'Profit' | 'End Round' | 'Cancel Bet' | 'Deposit Cancel' | 'Withdraw Cancel'| 'Game Counters' | 'Group Name' | 'Game Name' | 'Total Rounds' 
                      | 'Total Players' | 'Current' | 'No games data available' | 'Promotion Transactions Summary' | 'Promotional List' | 'Add Promo' 
                      | 'Promotion' | 'Descriptipn' | 'Active' | 'Total Days' | 'Expiration Date' |  'Inactive' | 'Edit Campaign' | 'Promotion Name' | 'Description'
                      | 'Enabled' | 'Cancel' | 'Update Campaign' | 'Add Server' | 'Label' | 'Username' | 'Password' | 'Endpoint' | 'Edit Game Server'| 'Update Server' 
                      | 'Add Game Server' | 'Adding...' | 'list of banners' | 'Add Banner' | 'Id' | 'Banner' | 'Link'| 'BigSelect' | 'SmallSelect'| 'No such server'
                      | 'Game code' | 'Group Current' | 'Assign' | 'Remove' | 'Imagen' | 'No groups assigned' | 'Save' | 'List of Games' | 'Add Game' | 'Game added successfully' 
                      | 'Print' | 'Dismiss' | 'Edit' | 'Edited successfully' | 'Select' | 'Existing imagen' | 'List of Managers' | 'Add Admin' | 'Group' | 'added successfully'
                      | 'Birthday' | 'YOUR REFERENCE WILL BE ASSIGNED AUTOMATICALLY' | 'Add user' | 'Edit Admin' | 'Keep current password' | 'Set new password' | 'List of Cashiers'
                      | 'No such User' | 'No User found' | 'Unassigned Users' | 'No unassigned users found' | 'List of players' | 'Add player' | 'Promo' | 'No players found' 
                      | 'Trans Id' | 'Player Id' | 'Available Promotions' | 'Trans. date' | 'Trans. time' | 'Trans. type' | 'Trans. amount' | 'Promotion Balance' | 'New Group' 
                      | 'List of play groups' | 'Add play Group' | 'New Play Groups' | 'Play Group added successfully' | 'Are you sure you want to delete the group' | 'Select a group...'
                      | 'Added successfully' | 'Select a parent group...' | 'Player' | 'New' | 'Error' | 'Successful' | 'Withdraw failed' | 'Deposit completed with warnings' 
                      | 'does not exist' | 'Owner Permissions' | 'As an Owner, you can create subgroups under any existing group in the system.' | 'Available Groups' | 'You can assign users to your group and any subgroups under your hierarchy.' | 'As an Owner, you can assign users to any group in the system.' | 'Available Players' | 'You can see players from your group, parent group, and subgroups.' | 'As an Owner, you can see all players in the system.'
                      | 'User Transactions' | 'Back to Player List' | 'No Transactions' | 'No transactions found for this user' | 'Transaction ID' | 'Date' | 'Cashable Amount' | 'Cashable Balance' | 'Promo Balance'
                      | 'Country Code' | 'Currency Code' | 'Promo Initial Balance' | 'Start Date' | 'Expiration Date' | 'Campaign Type' | 'Promotion Name' | 'Description' | 'Start Amount' | 'Campaign ID'
                      | 'Details' | 'of' | 'transactions' | 'Items per page' | 'Withdraw Cashier' | 'Withdrawal Amount' | 'Pin' | 'Type of Transaction' | 'Applied Promotion'
                      | 'Promotions Details' | 'In Front Page' | 'Download Report' | 'Download Summary' | 'No transactions to export'
                      | 'LOGIN' | 'Email or Phone Number' | 'Password' | 'Sign In' | 'Signing in...' | 'Please complete the captcha verification.' | 'Captcha verification error. Please try again.' | 'Login error. Please try again.' | 'Connection error. Please try again.' 
                      | 'Daily Limit' | 'Transaction Limit' | 'Groups Limits' | 'Date Transaction';

// Translation object for Spanish translations
export const translations: Record<Language, Record<TranslationKey, string>> = {
    en: {
        "User Profile": "User Profile",
        "First Name": "First Name",
        "Last Name": "Last Name",
        "E-mail": "E-mail",
        "Phone Number": "Phone Number",
        "Role": "Role",
        "Country": "Country",
        "Currency Code": "Currency Code",
        "Referral": "Referral",
        "Add Group": "Add Group",
        "Name": "Name",
        "Parent-id": "Parent-id",
        "Options": "Options",
        "Profile": "Profile",
        "Transactions": "Transactions", 
        "Sums": "Sums",
        "Campaigns": "Campaigns",
        "Rounds": "Rounds",
        "Game Servers": "Game Servers",
        "Games": "Games",
        "Banners": "Banners",
        "Administrators": "Administrators",
        "Cashiers": "Cashiers",
        "Unassigned": "Unassigned",
        "Players": "Players",
        "Games Groups": "Games Groups",
        "User Groups": "User Groups",
        "Logout": "Logout",
        "Transaction": "Transaction",
        "real time update active": "real time update active",
        "Start Date": "Start Date",
        "End Date": "End Date",
        "Search by name": "Search by name",
        "1 Week": "1 Week",
        "2 Weeks": "2 Weeks",
        "1 Month": "1 Month",
        "Summary by Type of Transaction": "Summary by Type of Transaction",
        "Type of transaction": "Type of transaction",
        "Count": "Count",
        "Amount": "Amount",
        "Total": "Total",
        "No transactions were found for the selected dates.": "No transactions were found for the selected dates.",
        "Transaction List": "Transaction List",
        "Transaction date": "Transaction date",
        "Type": "Type",
        "User": "User",
        "Balance": "Balance",
        "Money Amount": "Money Amount",
        "Money Balance": "Money Balance",
        "Promo Amount": "Promo Amount",
        "Previous": "Previous",
        "Page": "Page",
        "Next": "Next",
        "Total Promotion": "Total Promotion",
        "No promotion": "No promotion",
        "Groups": "Groups",
        "Select All": "Select All",
        "Loading": "Loading",
        "Search": "Search",
        "No results found": "No results found",
        "No data available for the selected period": "No data available for the selected period",
        "Transaction Summary": "Transaction Summary",
        "Less": "Less",
        "More": "More",
        "Deposit": "Deposit",
        "Withdraw": "Withdraw",
        "Deposit Profit": "Deposit Profit",
        "Bet": "Bet",
        "Win": "Win",
        "Profit": "Profit",
        "End Round": "End Round",
        "Cancel Bet": "Cancel Bet",
        "Deposit Cancel": "Deposit Cancel",
        "Withdraw Cancel": "Withdraw Cancel",
        "Game Counters": "Game Counters",
        "Group Name": "Group Name",
        "Game Name": "Game Name",
        "Total Rounds": "Total Rounds",
        "Total Players": "Total Players",
        "Current": "Current",
        "No games data available": "No games data available",
        "Promotion Transactions Summary": "Promotion Transactions Summary",
        "Promotional List": "Promotional List",
        "Add Promo": "Add Promo",
        "Promotion": "Promotion",
        "Descriptipn": "Descriptipn",
        "Active": "Active",
        "Total Days": "Total Days",
        "Expiration Date": "Expiration Date",
        "Inactive": "Inactive",
        "Edit Campaign": "Edit Campaign",
        "Promotion Name": "Promotion Name",
        "Description": "Description",
        "Enabled": "Enabled",
        "Cancel": "Cancel",
        "Update Campaign": "Update Campaign",
        "Add Server": "Add Server",
        "Label": "Label",
        "Username": "Username",
        "Password": "Password",
        "Endpoint": "Endpoint",
        "Edit Game Server": "Edit Game Server",
        "Update Server": "Update Server",
        "Add Game Server": "Add Game Server",
        "Adding...": "Adding...",
        "list of banners": "list of banners",
        "Add Banner": "Add Banner",
        "Id": "Id",
        "Banner": "Banner",
        "Link": "Link",
        "BigSelect": "BigSelect",
        "SmallSelect": "SmallSelect",
        "No such server": "No such server",
        "Game code": "Game code",
        "Group Current": "Group Current",
        "Assign": "Assign",
        "Remove": "Remove",
        "Imagen": "Imagen",
        "No groups assigned": "No groups assigned",
        "Save": "Save",
        "List of Games": "List of Games",
        "Add Game": "Add Game",
        "Game added successfully": "Game added successfully",
        "Print": "Print",
        "Dismiss": "Dismiss",
        "Edit": "Edit",
        "Edited successfully": "Edited successfully",
        "Select": "Select",
        "Existing imagen": "Existing imagen",
        "List of Managers": "List of Managers",
        "Add Admin": "Add Admin",
        "Group": "Group",
        "added successfully": "Added successfully",
        "Birthday": "Birthday",
        "YOUR REFERENCE WILL BE ASSIGNED AUTOMATICALLY": "your reference will be assigned automatically",
        "Add user": "Add user",
        "Edit Admin": "Edit Admin",
        "Keep current password": "Keep current password",
        "Set new password": "Set new password",
        "List of Cashiers": "List of Cashiers",
        "No such User": "No such User",
        "No User found": "No User found",
        "Unassigned Users": "Unassigned Users",
        "No unassigned users found": "No unassigned users found",
        "List of players": "List of players",
        "Add player": "Add player",
        "Promo": "Promo",
        "No players found": "No players found",
        "Trans Id": "Trans Id",
        "Player Id": "Player Id",
        "Available Promotions": "Available Promotions",
        "Trans. date": "Trans. date",
        "Trans. time": "Trans. time",
        "Trans. type": "Trans. type",
        "Trans. amount": "Trans. amount",
        "Promotion Balance": "Promotion Balance",
        "New Group": "New Group",
        "List of play groups": "List of play groups",
        "Add play Group": " Add play Group",
        "New Play Groups": "New Play Groups",
        "Play Group added successfully": "Play Group added successfully",
        "Are you sure you want to delete the group": "Are you sure you want to delete the group",
        "Select a group...": "Select a group...",
        "Added successfully": "Added successfully",
        "Select a parent group...": "Select a parent group...",
        "Player": "Player",
        "New": "New",
        "Error": "Error",
        "Successful": "Successful",
        "Withdraw failed": "Withdraw failed",
        "Deposit completed with warnings": "Deposit completed with warnings",
        "does not exist": "does not exist",
        "Owner Permissions": "Owner Permissions",
        "As an Owner, you can create subgroups under any existing group in the system.": "As an Owner, you can create subgroups under any existing group in the system.",
        "Available Groups": "Available Groups",
        "You can assign users to your group and any subgroups under your hierarchy.": "You can assign users to your group and any subgroups under your hierarchy.",
        "As an Owner, you can assign users to any group in the system.": "As an Owner, you can assign users to any group in the system.",
        "Available Players": "Available Players",
        "You can see players from your group, parent group, and subgroups.": "You can see players from your group, parent group, and subgroups.",
        "As an Owner, you can see all players in the system.": "As an Owner, you can see all players in the system.",
        "User Transactions": "User Transactions",
        "Back to Player List": "Back to Player List",
        "No Transactions": "No Transactions",
        "No transactions found for this user": "No transactions found for this user",
        "Transaction ID": "Transaction ID",
        "Date": "Date",
        "Cashable Amount": "Cashable Amount",
        "Cashable Balance": "Cashable Balance",
        "Promo Balance": "Promo Balance",
        "Country Code": "Country Code",
        "Promo Initial Balance": "Promo Initial Balance",
        "Campaign Type": "Campaign Type",
        "Start Amount": "Start Amount",
        "Campaign ID": "Campaign ID",
        "Details": "Details",
        "of": "of",
        "transactions": "transactions",
        "Items per page": "Items per page",
        "Withdraw Cashier": "Withdraw Cashier",
        "Withdrawal Amount": "Withdrawal Amount",
        "Pin": "Pin",
        "Type of Transaction": "Type of Transaction",
        "Applied Promotion": "Applied Promotion",
        "Promotions Details": "Promotions Details",
        "In Front Page": "In Front Page",
        "Download Report": "Download Report",
        "Download Summary": "Download Summary",
        "No transactions to export": "No transactions to export",
        "LOGIN": "LOGIN",
        "Email or Phone Number": "Email or Phone Number",
        "Sign In": "Sign In",
        "Signing in...": "Signing in...",
        "Please complete the captcha verification.": "Please complete the captcha verification.",
        "Captcha verification error. Please try again.": "Captcha verification error. Please try again.",
        "Login error. Please try again.": "Login error. Please try again.",
        "Connection error. Please try again.": "Connection error. Please try again.",
        "Daily Limit": "Daily Limit",
        "Transaction Limit": "Transaction Limit",
        "Groups Limits": "Groups Limits",
        "Date Transaction": "Date Transaction"
    },
    es: {
        "User Profile": "Perfil de Usuario",
        "First Name": "Nombre",
        "Last Name": "Apellido",
        "E-mail": "Correo electrónico",
        "Phone Number": "Número de teléfono",
        "Role": "Rol",
        "Country": "País",
        "Currency Code": "Código de moneda",
        "Referral": "Referencia",
        "Add Group": "Agregar Grupo",
        "Name": "Nombre",
        "Parent-id": "Grupo principal",
        "Options": "Opciones",
        "Profile": "Perfil",
        "Transactions": "Transacciones",
        "Sums": "Sumas",
        "Campaigns": "Campañas",
        "Rounds": "Rondas",
        "Game Servers": "Servidores de juegos",
        "Games": "Juegos",
        "Banners": "Banners",
        "Administrators": "Administradores",
        "Cashiers": "Cajeros",
        "Unassigned": "Sin asignar",
        "Players": "Jugadores",
        "Games Groups": "Grupos de juegos",
        "User Groups": "Grupos de usuarios",
        "Logout": "Cerrar sesión",
        "Transaction": "Transacción",
        "real time update active": "actualización en tiempo real activa",
        "Start Date": "Fecha de inicio",
        "End Date": "Fecha de fin",
        "Search by name": "Buscar por nombre",
        "1 Week": "1 Semana",
        "2 Weeks": "2 Semanas",
        "1 Month": "1 Mes",
        "Summary by Type of Transaction": "Resumen por tipo de transacción",
        "Type of transaction": "Tipo de transacción",
        "Count": "Conteo",
        "Amount": "Cantidad",
        "Total": "Total",
        "No transactions were found for the selected dates.": "No se encontraron transacciones para los datos seleccionados.",
        "Transaction List": "Lista de transacciones",
        "Transaction date": "Fecha de transacción",
        "Type": "Tipo",
        "User": "Usuario",
        "Balance": "Balance",
        "Money Amount": "Cantidad de dinero",
        "Money Balance": "Balance de dinero",
        "Promo Amount": "Promoción",
        "Previous": "Anterior",
        "Page": "Página",
        "Next": "Siguiente",
        "Total Promotion": "Promoción total",
        "No promotion": "Sin promoción",
        "Groups": "Grupos",
        "Select All": "Seleccionar todo",
        "Loading": "Cargando",
        "Search": "Buscar",
        "No results found": "No se encontraron resultados",
        "No data available for the selected period": "No hay datos disponibles para el periodo seleccionado",
        "Transaction Summary": "Resumen de transacciones",
        "Less": "Menos",
        "More": "Más",
        "Deposit": "Depósito",
        "Withdraw": "Retiro",
        "Deposit Profit": "Profit",
        "Bet": "Apuesta",
        "Win": "Ganancia",
        "Profit": "Profit",
        "End Round": "Ronda",
        "Cancel Bet": "Apuesta cancelalda",
        "Deposit Cancel": "Deposito cancelado",
        "Withdraw Cancel": "Cobro cancelaldo",
        "Game Counters": "Contadore de juegos",
        "Group Name": "Nombre del grupo",
        "Game Name": "Nombre del juego",
        "Total Rounds": "Total de rondas",
        "Total Players": "Total de jugadores",
        "Current": "Actual",
        "No games data available": "No hay datos de juegos disponibles",
        "Promotion Transactions Summary": "Resumen de transacciones de promoción",
        "Promotional List": "Lista de promociones",
        "Add Promo": "Agregar Promo",
        "Promotion": "Promoción",
        "Descriptipn": "Descripción",
        "Active": "Estatus",
        "Total Days": "Tiempo de Promoción",
        "Expiration Date": "Fecha de Expiración",
        "Inactive": "Inactivo", 
        "Edit Campaign": "Editar campaña",
        "Promotion Name": "Nombre de promoción",
        "Description": "Descripción",
        "Enabled": "Habilitado",
        "Cancel": "Cancelar",
        "Update Campaign": "Actualizar campaña",
        "Add Server": "Agregar servidor",
        "Label": "Etiqueta",
        "Username": "Nombre de servidor",
        "Password": "Contraseña",
        "Endpoint": "Url de servidor",
        "Edit Game Server": "Editar servidor de juego",
        "Update Server": "Actualizar servidor",
        "Add Game Server": "Agregar servidor de juego",
        "Adding...": "Agregando...",
        "list of banners": "lista de banners",
        "Add Banner": "Agregar Banner",
        "Id": "Id",
        "Banner": "Banner",
        "Link": "Enlace",
        "BigSelect": "BigSelect",
        "SmallSelect": "SmallSelect",
        "No such server": "No existe ese servidor",
        "Game code": "Código de juego",
        "Group Current": "Grupo actual",
        "Assign": "Asignar",
        "Remove": "Eliminar",
        "Imagen": "Imagen",
        "No groups assigned": "No hay grupos asignados",
        "Save": "Guardar",
        "List of Games": "Lista de juegos",
        "Add Game": "Agregar juego",
        "Game added successfully": "Juego agregado correctamente",
        "Print": "Imprimir",
        "Dismiss": "Descartar",
        "Edit": "Editar",
        "Edited successfully": "Editado correctamente",
        "Select": "Seleccionar",
        "Existing imagen": "Imagen existente",
        "List of Managers": "Lista de administradores",
        "Add Admin": "Agregar administrador",
        "Group": "Grupo",
        "added successfully": "Agregado correctamente",
        "Birthday": "Fecha de nacimiento",
        "YOUR REFERENCE WILL BE ASSIGNED AUTOMATICALLY": "Su referencia se asignará automáticamente",
        "Add user": "Agregar usuario",
        "Edit Admin": "Editar administrador",
        "Keep current password": "Mantener contraseña actual",
        "Set new password": "Establecer nueva contraseña",
        "List of Cashiers": "Lista de Cajeros",
        "No such User": "No existe ese usuario",
        "No User found": "No se encontraro usuario",
        "Unassigned Users": "Usuarios sin asignar",
        "No unassigned users found": "No se encontraron usuarios sin asignar",
        "List of players": "Lista de jugadores",
        "Add player": "Agregar jugador",
        "Promo": "Promoción",
        "No players found": "No se encontro jugador",
        "Trans Id": "Id de transacción",
        "Player Id": "Id de jugador",
        "Available Promotions": "Promociones disponibles",
        "Trans. date": "Fecha de transacción",
        "Trans. time": "Hora de transacción",
        "Trans. type": "Tipo de transacción",
        "Trans. amount": "Cantidad de transacción",
        "Promotion Balance": "Balance de promoción",
        "New Group": "Nuevo grupo",
        "List of play groups": "Lista de grupos de juegos",
        "Add play Group": " Agregar grupo de juegos",
        "New Play Groups": "Nuevo grupo de juegos",
        "Play Group added successfully": "Grupo de juegos agregado correctamente",
        "Are you sure you want to delete the group": "¿Está seguro de que desea eliminar el grupo",
        "Select a group...": "Seleccione un grupo...",
        "Added successfully": "Agregado correctamente",
        "Select a parent group...": "Seleccione un grupo padre...",
        "Player": "Jugador",
        "New": "Nuevo",
        "Error": "Error",
        "Successful": "Exitoso",
        "Withdraw failed": "Retiro fallido",
        "Deposit completed with warnings": "Depósito completado con advertencias",
        "does not exist": "no existe",
        "Owner Permissions": "Permisos de Propietario",
        "As an Owner, you can create subgroups under any existing group in the system.": "Como Propietario, puede crear subgrupos bajo cualquier grupo existente en el sistema.",
        "Available Groups": "Grupos Disponibles",
        "You can assign users to your group and any subgroups under your hierarchy.": "Puede asignar usuarios a su grupo y cualquier subgrupo bajo su jerarquía.",
        "As an Owner, you can assign users to any group in the system.": "Como Propietario, puede asignar usuarios a cualquier grupo en el sistema.",
        "Available Players": "Jugadores Disponibles",
        "You can see players from your group, parent group, and subgroups.": "Puede ver jugadores de su grupo, grupo padre y subgrupos.",
        "As an Owner, you can see all players in the system.": "Como Propietario, puede ver todos los jugadores en el sistema.",
        "User Transactions": "Transacciones de Usuario",
        "Back to Player List": "Volver a Lista de Jugadores",
        "No Transactions": "Sin Transacciones",
        "No transactions found for this user": "No se encontraron transacciones para este usuario",
        "Transaction ID": "ID de Transacción",
        "Date": "Fecha",
        "Cashable Amount": "Movimientos",
        "Cashable Balance": "Total",
        "Promo Balance": "Balance de Promoción",
        "Country Code": "Código de País",
        "Promo Initial Balance": "Balance Inicial de Promo",
        "Campaign Type": "Tipo de Campaña",
        "Start Amount": "Cantidad Inicial",
        "Campaign ID": "ID de Campaña",
        "Details": "Detalles",
        "of": "de",
        "transactions": "transacciones",
        "Items per page": "Elementos por página",
        "Withdraw Cashier": "Retiro de Cajero",
        "Withdrawal Amount": "Cantidad de Retiro",
        "Pin": "Código de Retiro",
        "Type of Transaction": "Tipo de Transacción",
        "Applied Promotion": "Promoción Aplicada",
        "Promotions Details": "Detalles de Promociones",
        "In Front Page": "En página principal",
        "Download Report": "Descargar Reporte",
        "Download Summary": "Descargar Resumen",
        "No transactions to export": "No hay transacciones para exportar",
        "LOGIN": "INICIAR SESIÓN",
        "Email or Phone Number": "Correo Electrónico o Número de Teléfono",
        "Sign In": "Iniciar Sesión",
        "Signing in...": "Iniciando sesión...",
        "Please complete the captcha verification.": "Por favor, completa la verificación del captcha.",
        "Captcha verification error. Please try again.": "Error en la verificación del captcha. Por favor, inténtalo de nuevo.",
        "Login error. Please try again.": "Error al iniciar sesión. Por favor, inténtalo de nuevo.",
        "Connection error. Please try again.": "Error de conexión. Por favor, inténtalo de nuevo.",
        "Daily Limit": "Límite diario",
        "Transaction Limit": "Límite de transacción",
        "Groups Limits": "Límites de grupos",
        "Date Transaction": "Fecha de Transacción"
    }
};

// Current language store (default to Spanish)
export const currentLanguage = writable<Language>('es');

// Function to set the current language
export function setLanguage(lang: Language) {
    currentLanguage.set(lang);
}

// Reactive translate function
export function createTranslate() {
    return derived(currentLanguage, ($currentLanguage) => {
        return (text: TranslationKey): string => {
            return translations[$currentLanguage][text] || text;
        };
    });
}

// Export the reactive translate function
export const translate = createTranslate();

// Function to get current language
export function getCurrentLanguage(): Language {
    let lang: Language = 'es';
    currentLanguage.subscribe(value => {
        lang = value;
    })();
    return lang;
}
